export type RoomAssetLink = {
  sfid?: string;
  name: string;
};

export const assetKey = (asset: RoomAssetLink) => asset.sfid ?? asset.name;

export type CategoryRoom = {
  id: number;
  assetName: string;
  assetSfId?: string;
  asiaOnly: boolean;
};

export type RoomPricing = {
  allocation: string;
  occupancy: string;
  sellByLos: Record<number, string>;
  sellEditedByLos: Record<number, boolean>;
  netByLos: Record<number, string>;
  extraNightSell: string;
  extraNightSellEdited: boolean;
  extraNightNet: string;
  otaPrice: string;
};

export type NetRateFormulaState = {
  netPercent: string;
  applyToExtraNight: boolean;
  scope: 'all' | 'choose';
  selectedRoomIds: Array<number>;
};

export type OptionState = {
  lengthsOfStay: Array<number>;
  roomsByCategory: Array<Array<CategoryRoom>>;
  selectedLos: number;
  pricingByRoomId: Record<number, RoomPricing>;
  netRateFormula: NetRateFormulaState;
};
